// src/components/liability/LiabilitiesMobileView.tsx
import React from 'react';
import { Edit, Trash2, Search, RefreshCw } from 'lucide-react';
import { LiabilityData } from '../../pages/Liability'; // Adjust path
import Pagination from '../shared/Pagination'; // Adjust path

interface LiabilitiesMobileViewProps {
  paginatedData: LiabilityData[];
  apiLoading: boolean;
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleEdit: (liability: LiabilityData) => void;
  handleDelete: (id: string) => void;
  getLabel: (group: string, value: string) => string;
  formatCurrency: (value: string | number) => string;
  formatDate: (date: string) => string;
  paginationProps: any;
}

const LiabilityCard: React.FC<Omit<LiabilitiesMobileViewProps, 'paginatedData' | 'apiLoading' | 'searchTerm' | 'onSearchChange' | 'paginationProps'> & { liability: LiabilityData }> = ({
    liability, handleEdit, handleDelete, getLabel, formatCurrency, formatDate
}) => (
    <div className="bg-white rounded-lg p-3 shadow border border-gray-200 flex flex-col">
        <div className="flex justify-between items-start mb-2">
            <div className="text-red-800 font-bold truncate text-sm">
                {getLabel('liabilityType', liability.liabilityType) || 'Liability'}
            </div>
            <div className="flex space-x-1">
                <button onClick={() => handleEdit(liability)} className="p-1 text-red-600"><Edit className="w-4 h-4" /></button>
                <button onClick={() => handleDelete(liability.id)} className="p-1 text-red-600"><Trash2 className="w-4 h-4" /></button>
            </div>
        </div>
        <div className="mb-2">
            <p className="text-base font-bold text-red-600 text-center truncate">{formatCurrency(liability.liabilityOutstandingAmount)}</p>
        </div>
        <div className="space-y-1 text-xs text-gray-600 text-center">
            <div className="text-gray-800 font-medium truncate">{getLabel('liabilitySubType', liability.liabilitySubType)}</div>
            <div className="text-gray-600">{getLabel('liabilityFrequency', liability.liabilityFrequency)}</div>
            <div className="text-gray-600">{formatCurrency(liability.liabilityInstalmentAmount)}</div>
            {liability.liabilityEndDate && <div className="text-gray-600">End: {formatDate(liability.liabilityEndDate)}</div>}
        </div>
    </div>
);

const LiabilitiesMobileView: React.FC<LiabilitiesMobileViewProps> = ({ paginatedData, apiLoading, searchTerm, onSearchChange, paginationProps, ...rest }) => {
    return (
        <div className="md:hidden">
            <div className="p-2">
                <div className="relative max-w-md mx-auto mb-4">
                    <input type="text" placeholder="Search liabilities..." value={searchTerm} onChange={onSearchChange} className="w-full p-2 pl-10 border rounded-lg text-sm" />
                    <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                </div>
            </div>
            {apiLoading ? (
                <div className="text-center py-12"><RefreshCw className="w-6 h-6 animate-spin text-red-600" /></div>
            ) : (
                <div className="grid grid-cols-2 gap-4 px-2">
                    {paginatedData.map(liability => <LiabilityCard key={liability.id} liability={liability} {...rest} />)}
                </div>
            )}
            {paginationProps.totalItems > paginationProps.itemsPerPage && !apiLoading && (
                <Pagination {...paginationProps} isMobile />
            )}
        </div>
    );
};

export default LiabilitiesMobileView;